module.exports = __webpack_public_path__ + "static/media/perspective.e430379c.png";